export default {
  'member.memberId': '账号ID',
  'member.enterMemberId': '请输入账号ID',
  'member.phone': '手机号',
  'member.email': '邮箱',
  'member.accountStatus': '账号状态',
  'member.signUpStatus': '报名状态',
  'member.notSignUp': '未报名',
  'member.inCompetition': '比赛中',
  'member.inSignUp': '报名中',
  'member.totalInvite': '总邀请',
  'member.usedTickets': '已使用门票',
  'member.remainTickets': '剩余门票',
  'member.balance': '余额',
  'member.totalBonus': '总奖金',
  'member.totalExchange': '总兑换',
  'member.totalWithdraw': '总出款',
  'member.inviteCode': '邀请码',
  'member.enterInviteCode': '请输入邀请码',
  'member.parentId': '上级账号ID',
  'member.enterParentId': '请输入上级账号ID',
  'member.createTime': '注册时间',
  'member.lastLoginTime': '最后登录时间',
  'member.balanceFilter': '余额',
  'member.hasBalance': '有余额',
  'member.noBalance': '无余额',
  'member.enterPhone': '请输入手机号',
  'member.enterEmail': '请输入邮箱',
  'member.password': '密码',
  'member.enterPassword': '请输入密码',
  'member.memberInfo': '会员信息',
  'member.withdrawStatus': '出款状态',
  'member.username': '用户名',
  'member.disableTooltip': '禁用: 无法登录，报名，出款',
  'member.getListFailed': '获取会员列表失败',
  'member.exportFileName': '会员列表-{date}.csv',
  'member.userId': '用户标识',
  'member.passwordMin8': '密码必须至少8个字符',
  'member.invalidPhone': '请输入9开头的10位号码',
  'member.invalidPhone243': '请输入10位号码',
  'member.usernameRegex': '用户名需为8-20位的字母或数字, 不能包含符号',
  'member.withdrawSum': '出款次数',

  'member.levelName': '层级名称',
  'member.peopleCount': '人数',
  'member.singleWithdrawAmount': '单笔出款额',
  'member.permissions': '权限',
  'member.operationTime': '操作时间',
  'member.withdrawal': '出款',
  'member.invitationRewards': '邀请奖励',
  'member.dailyWithdrawApplyLimit': '单日出款申请提交次数',
  'member.min': '最低',
  'member.max': '最高',
  'member.cumulativeSuccessWithdrawLimit': '累计成功出款总额上限',
  'member.daily': '单日',
  'member.weekly': '单周',
  'member.monthly': '单月',
  'member.times': '次',

  'member.accountId': '账号ID',
  'member.ip': 'IP',
  'member.deviceType': '设备类型',
  'member.iosH5': 'iOS H5',
  'member.androidH5': 'Android H5',
  'member.macPc': 'Mac PC',
  'member.windowsPc': 'Windows PC',
  'member.other': '其他',
  'member.deviceCode': '设备码',
  'member.address': '地址',
  'member.operationType': '操作标识',
  'member.register': '注册',
  'member.login': '登录',
  'member.loginTime': '登录时间',
  'member.loginLogExportFileName': '登录查询-{date}.csv',

  'member.hierarchyLevelId': '层级',

  'member.registerSource': '注册来源',
  'member.registerSourceSelf': '自主',
  'member.registerDomain': '注册域名',
  'member.channelId': '渠道ID',
  'member.channelName': '渠道名称',
  'member.kycStatus': 'KYC',
  'member.kycVerified': '已认证',
  'member.kycUnverified': '未认证',

  // "member.riskLabel": "风控标签",

  'member.parentStatus': '上级',
  'member.subordinateStatus': '下级',
  'member.relationHas': '有',
  'member.relationNone': '无',

  'member.riskLabel': '风控标签',

  'invitation.details': '邀请明细',

  'member.batchOperations': '批量操作',

  'member.accountIds': '账号ID',
  'member.inputMultipleAccountIdsPlaceholder':
    '输入多个账号ID，换行、逗号或空格隔开，最多1000个账号ID',
  'member.pleaseInputAccountIds': '请输入账号ID',
  'member.maxInputLimitExceeded': '最多只能输入 1000 个账号ID，当前已输入 {current} 个',
  'member.maxUserIdLengthExceeded': '账号ID最长 {max} 位，请检查：{id}',
  'member.hierarchy': '层级',
  'member.pleaseSelectHierarchy': '请选择层级',

  'member.withdrawalStatus': '出款状态',

  'member.pleaseInputRemark': '请输入备注',
  // 验证码
  'member.smsSendTime': '发送时间',
  'member.smsStatus': '发送状态',
  'member.smsNumber': '号码',
  'member.smsCode': '验证码',
  'member.smsViewerRecord': '查看人及时间',
  'member.smsTypePhone': '手机',
  'member.smsSendSuccess': '发送成功',
  'member.smsSendFail': '发送失败',
  'member.smsVerifySuccess': '验证成功',
  'member.smsVerifyFail': '验证失败',
  'member.smsCodeTitle': '验证码：{code}',
  'member.smsExportFileName': '验证码记录-{date}.csv',

  // KYC
  'member.kycSubmitTime': '提交时间',
  'member.kycName': '姓名',
  'member.kycCertType': '证件类型',
  'member.kycCertNo': '证件号码',
  'member.kycAuditStatus': '审核状态',
  'member.kycRejectReason': '拒绝原因',
  'member.kycAuditorTime': '审核人及时间',
  'member.kycPending': '待审核',
  'member.kycPassed': '通过',
  'member.kycRejected': '拒绝',
  'member.kycCertIdCard': '身份证',
  'member.kycCertDriverLicense': '驾驶证',
  'member.kycAudit': '审核',
  'member.kycCertImages': '证件图片',
  'member.kycPortrait': '人像面',
  'member.kycEmblem': '国徽面',
  'member.kycHandheld': '手持证件照',
  'member.kycAuditResult': '审核结果',
  'member.kycRejectReasonPlaceholder': '拒绝原因',
  'member.kycRejectReasonRequired': '请输入拒绝原因',
  'member.kycAuditor': '审核人',
  'member.kycAuditTime': '审核时间',
};
